import { Panel } from '../panel.class';
import { Vertex3 } from '../../../spatial-classes';

export type PanelToIslandResolver = (localX: number, localZ: number) => Vertex3;

// Panel-local (x, z) -> island-local, matching the renderer's rotate(-getOriginAngle()) then translate(center).
export const getPanelToIslandResolver = (panel: Panel): PanelToIslandResolver => {
	const origin = panel.center;
	const angle = -panel.getOriginAngle();

	return (localX: number, localZ: number): Vertex3 => {
		const point = new Vertex3({ dataIn: { x: localX, y: 0, z: localZ } });
		point.add(origin);
		return point.rotateAxis(origin, angle, 'y');
	};
};
